import React, { useState, useRef, useEffect } from 'react';
import { FiCamera } from 'react-icons/fi';

const PersonDetailsForm = ({ isOpen, onClose, personData, onSave }) => {
  const [formData, setFormData] = useState({
    title: '-',
    firstName: '',
    middleName: '',
    lastName: '',
    suffix: '-',
    idMark: '',
    mobileNo: '-',
    aadharNo: '0',
    villageName: 'इनाम धामणी'
  });

  const [photoPreview, setPhotoPreview] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (personData) {
      setFormData({
        title: personData.title || '-',
        firstName: personData.firstName || personData.personName?.split(' ')[0] || '',
        middleName: personData.middleName || personData.personName?.split(' ')[1] || '',
        lastName: personData.lastName || personData.personName?.split(' ')[2] || '',
        suffix: personData.suffix || '-',
        idMark: personData.idMark || '',
        mobileNo: personData.mobileNo || '-',
        aadharNo: personData.aadharNo || '0',
        villageName: personData.villageName || 'इनाम धामणी'
      });
      // Reset photo if needed, or set it if personData has photo
    }
  }, [personData, isOpen]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChooseFileClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = () => {
    onSave && onSave({ ...formData, photo: photoPreview });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl overflow-hidden max-h-[90vh] overflow-y-auto">
        
        {/* Header */}
        <div className="bg-[#267c77] text-white p-3 px-6">
          <h2 className="text-xl font-semibold">व्यक्तीची माहिती</h2>
        </div>

        {/* Content */}
        <div className="p-8">
            <div className="space-y-6">
                
                {/* Title */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">शीर्षक</label>
                    <div className="md:col-span-3">
                         <select 
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         >
                            <option>-</option>
                            <option>श्री</option>
                            <option>श्रीमती</option>
                            <option>कु.</option>
                         </select>
                    </div>
                </div>

                {/* First Name */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">पहिले नाव <span className="text-red-500">*</span></label>
                    <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            placeholder="पहिले नाव"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         />
                    </div>
                </div>

                {/* Middle Name */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">वडिलांचे/पतीचे नाव</label>
                     <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="middleName"
                            value={formData.middleName}
                            onChange={handleInputChange}
                            placeholder="वडिलांचे/पतीचे नाव"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         />
                    </div>
                </div>

                {/* Last Name */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">आडनाव</label>
                     <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            placeholder="आडनाव"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         />
                    </div>
                </div>

                 {/* Suffix */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">सफिक्स</label>
                    <div className="md:col-span-3">
                         <select 
                            name="suffix"
                            value={formData.suffix}
                            onChange={handleInputChange}
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         >
                            <option>-</option>
                            <option>Jr.</option>
                            <option>Sr.</option>
                         </select>
                    </div>
                </div>

                {/* ID Mark */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">ओळख चिन्ह</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="idMark"
                            value={formData.idMark}
                            onChange={handleInputChange}
                            placeholder="ओळख चिन्ह"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         />
                    </div>
                </div>

                {/* Mobile No */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">भ्रमणध्वनी क्र</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="mobileNo"
                            value={formData.mobileNo}
                            onChange={handleInputChange}
                            placeholder="भ्रमणध्वनी क्र"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         />
                    </div>
                </div>

                {/* Aadhar No */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">आधार क्रमांक</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="aadharNo"
                            value={formData.aadharNo}
                            onChange={handleInputChange}
                            placeholder="आधार क्रमांक"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         />
                    </div>
                </div>

                 {/* Village Name */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">गावाचे नाव</label>
                    <div className="md:col-span-3">
                         <select 
                            name="villageName"
                            value={formData.villageName}
                            onChange={handleInputChange}
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77]"
                         >
                            <option>इनाम धामणी</option>
                         </select>
                    </div>
                </div>

            </div>

             {/* Footer Buttons */}
             <div className="mt-8 flex justify-center gap-4 border-t pt-6">
                <button 
                  onClick={handleSubmit}
                  className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
                >
                    साठविणे
                </button>
                <button 
                  onClick={onClose}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition font-medium"
                >
                    रद्द करा
                </button>
             </div>
        </div>
      </div>
    </div>
  );
};

export default PersonDetailsForm;
